// extracted by mini-css-extract-plugin
export default {"root":"IconLocalOffer_root__rUi6G"};